import React from 'react';
import withStyles from '@mui/styles/withStyles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import BackIcon from '@mui/icons-material/ArrowBack';
import {useHistory} from 'react-router-dom';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  toolbar: {
    backgroundColor: '#fff',
  },
  menuIcon: {
    color: '#000',
  },
});

const Bar = withStyles(styles)(({classes, children, handler, customButton}) => {
  let history = useHistory();
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.toolbar}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%">
            <IconButton color="inherit" onClick={history.goBack} size="large">
              <BackIcon color="primary" />
            </IconButton>
            {children}
            <IconButton onClick={handler} color="inherit" size="large">
              {customButton}
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  );
});

export default Bar;
